export default "__VITE_PUBLIC_ASSET__42c7e238__"